<div class="search-results-container">
  <ng-container *ngIf="dataToDisplay.length > 1; else elsePart">
    <div class="results-count my-3">{{ dataToDisplay.length }} records found, please select one</div>
    <p-table
      [columns]="cols"
      [value]="dataToDisplay"
      scrollDirection="horizontal"
      [style]="{ width: '100%' }"
      [tableStyle]="{ 'min-width': '100%', width: 'max-content' }"
      styleClass="p-datatable-sm"
      [scrollable]="true"
      selectionMode="single"
      [(selection)]="selectedData"
      [scrollHeight]="innerHeight + 'px'"
      [tableStyle]="{ 'min-width': '35rem' }"
      selectionMode="single"
      (onRowSelect)="onRowSelect()"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of cols">
            <th>
              {{ col.label }}
              <span class="fts">
                <span class="sort" (click)="sortByColumn(col.name)">
                  <ng-container *ngIf="col.hasOwnProperty('isAsc'); else others">
                    <ng-container *ngIf="col.isAsc; else falseBlock">
                      <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                    </ng-container>
                    <ng-template #falseBlock>
                      <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                    </ng-template>
                  </ng-container>

                  <ng-template #others>
                    <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort.png" />
                  </ng-template>
                </span>
              </span>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [pSelectableRow]="rowData">
          <ng-container *ngFor="let col of cols">
            <td>
              {{ col.name === 'PhoneNumbers' ? rowData[col.name][0]?.Number : rowData[col.name] }}
            </td>
          </ng-container>
          <td *ngIf="isEmail">
            <span [ngClass]="rowData.isSelected ? 'plus-sign-selected' : 'plus-sign'">+</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>

  <ng-template #elsePart>
    <!-- <div *ngIf="showElsePart"> -->
    <div *ngIf=" ( showElsePart)"><!--getDialerType() !== 'Keypad' || getDialerType() === 'Keypad' &&-->
      <hr class="hr1" />
      <div class="mb-3" *ngIf="originalSearchResult.Response.Data.length > 1">
        <button class="link-btn large p-0" (click)="retrunToPrevious()">< Back</button>
      </div>

      <div class="container-fluid column main-data" *ngIf="searchType === 'user'">
        <div class="row">
          <div class="user-name ps-0">
            {{ dataToDisplay[0]['FullName'] }}
          </div>
          <!-- <div class="col-1 p-0">
          <img [src]="URL" class="user-pic" alt="User Icon" id="imgAvatar" />
        </div> -->
          <!-- <div class="col-3" style="padding-left: 0 !important">
          <div
            style="
              text-align: left;
              font-weight: 700;
              font-size: 1.125rem;
              line-height: 1.375rem;
              letter-spacing: 0rem;
              color: #000048;
              opacity: 1;
            "
          >
            {{ dataToDisplay[0]['FullName'] }}
          </div>
          <div
            style="
              text-align: left;
              font-weight: 500;
              font-size: 0.75rem;
              line-height: 0.875rem;

              letter-spacing: 0rem;
              color: #53565a;
              opacity: 1;
            "
          >
            Process Executive - (PE)
          </div>
        </div>
        <div class="col-2">
          <div style="font-weight: 500; font-size: 0.688rem; line-height: 0.813rem; padding-bottom: 0.313rem">
            <img
              src="{{ baseHref }}/assets/images/icon-location.svg"
              alt="Italian Trulli"
              style="padding-right: 0.313rem"
            />{{ dataToDisplay[0]['City'] }}
          </div>

          <div style="font-weight: 500; font-size: 0.688rem; line-height: 0.813rem">
            <img
              src="{{ baseHref }}/assets/images/icon-phone.svg"
              alt="Italian Trulli"
              style="padding-right: 0.313rem"
            />{{ dataToDisplay[0]['PhoneNumbers'][0]?.Number }}
          </div>
        </div> -->
          <hr style="height: 0.063rem; border: 0.063rem solid #97999b; width: 100%; margin-top: 0.938rem" />

          <form action="#" class="ps-0">
            <ng-container *ngFor="let col of filteredData">
              <div class="form-row">
                <div class="input-data" *ngIf="col?.label != 'DateOfBirth'">
                  <label for="">{{ col.label }}</label>
                  <input type="text" title="{{ col.value }}" value="{{ col.value }}" style="padding-bottom: 0.5rem" />
                </div>
                <div *ngIf="col?.label == 'DateOfBirth'" class="input-data">
                  <label for="">{{ col.label }}</label>
                  <input
                    type="text"
                    title="{{ col.value | custdateonly }}"
                    value="{{ col.value | custdateonly }}"
                    style="padding-bottom: 0.5rem"
                  />
                </div>
              </div>
            </ng-container>
            <!-- <ng-container *ngFor="let col of colsDetail">
            <div class="form-row">
              <div class="input-data">
                <label for="">{{ col.label }}</label>
                <input type="text" value="{{ dataToDisplay[0][col.name] }}" style="padding-bottom: 0.5rem" />
              </div>
            </div>
          </ng-container> -->
          </form>
        </div>
      </div>

      <div class="scrollable-container" *ngIf="searchType === 'agent'">
        <form action="#">
          <ng-container *ngFor="let col of filteredData">
            <div class="form-row">
              <div class="input-data" *ngIf="col?.label != 'DateOfBirth'">
                <label for="">{{ col.label }}</label>
                <input type="text" title="{{ col.value }}" value="{{ col.value }}" style="padding-bottom: 0.5rem" />
              </div>
              <div *ngIf="col?.label == 'DateOfBirth'" class="input-data">
                <label for="">{{ col.label }}</label>
                <input
                  type="text"
                  title="{{ col.value | custdate }}"
                  value="{{ col.value | custdate }}"
                  style="padding-bottom: 0.5rem"
                />
              </div>
            </div>
          </ng-container>
          <!-- <ng-container *ngFor="let col of colsDetail">
          <div class="form-row">
            <div class="input-data">
              <label for="">{{ col.label }}</label>
              <input type="text" value="{{ dataToDisplay[0][col.name] }}" style="padding-bottom: 0.5rem" />
            </div>
          </div>
        </ng-container> -->
        </form>
      </div>
    </div>
  </ng-template>
</div>
